import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import { containerAnimation, animation } from "../../utils/animation";

const NotFound = () => {
  return (
    <motion.section
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
      className="relative overflow-hidden bg-white"
    >
      <div className="absolute inset-0">
        <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-orange/20 blur-3xl" />
        <div className="absolute -bottom-20 -left-24 h-80 w-80 rounded-full bg-primaryRed/20 blur-3xl" />
        <div className="absolute right-10 top-1/2 h-28 w-28 -translate-y-1/2 rounded-3xl bg-primary/5" />
      </div>

      <div className="container relative py-20 xl:py-24 lg:py-24">
        <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-10 items-center">
          <motion.div variants={animation} className="col-span-1">
            <p className="text-sm font-source uppercase tracking-[0.3em] text-headerGrey">
              Page Not Found
            </p>
            <h1 className="mt-4 text-5xl leading-tight font-fraunces-bold tracking-tight text-black">
              The route you tried doesn&apos;t exist on this website.
            </h1>
            <p className="mt-4 text-lg xl:text-xl lg:text-xl font-source text-headerGrey max-w-2xl">
              It looks like this page was moved, renamed, or never existed. Use
              the options below to get back to trusted wholesale inventory and
              account tools.
            </p>

            <div className="mt-8 flex flex-wrap gap-4">
              <Link
                to="/"
                className="px-6 py-3 rounded-full bg-primary text-white font-source text-base tracking-wide shadow-lg shadow-black/10 hover:bg-black transition"
              >
                Back to Home
              </Link>
              <Link
                to="/shop"
                className="px-6 py-3 rounded-full border border-greyBorder text-black font-source text-base tracking-wide hover:border-primary hover:text-primary transition"
              >
                Browse the Shop
              </Link>
              <Link
                to="/contact-us"
                className="px-6 py-3 rounded-full bg-white text-primary font-source text-base tracking-wide border border-primary/20 hover:border-primary hover:shadow-lg transition"
              >
                Contact Support
              </Link>
            </div>
          </motion.div>

          <motion.div variants={animation} className="col-span-1">
            <div className="relative bg-gradient-to-br from-white via-greyBg to-white rounded-3xl border border-greyBorder p-10 shadow-2xl shadow-black/5">
              <div className="absolute -top-6 -left-6 bg-primary text-white px-4 py-2 rounded-full text-sm font-source">
                Error 404
              </div>
              <div className="text-7xl xl:text-8xl lg:text-8xl font-fraunces-bold text-primary">
                404
              </div>
              <p className="mt-3 text-lg font-source text-headerGrey">
                Need help right away? Our logistics team can reroute urgent
                shipments and keep your shelves stocked.
              </p>
              <div className="mt-6 grid grid-cols-1 gap-4">
                <div className="flex items-center gap-3 rounded-2xl bg-white border border-greyBorder px-4 py-3">
                  <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-fraunces-bold">
                    1
                  </div>
                  <p className="text-base font-source text-headerGrey">
                    Verify the URL or search the catalog.
                  </p>
                </div>
                <div className="flex items-center gap-3 rounded-2xl bg-white border border-greyBorder px-4 py-3">
                  <div className="h-10 w-10 rounded-full bg-primaryRed/30 flex items-center justify-center text-primary font-fraunces-bold">
                    2
                  </div>
                  <p className="text-base font-source text-headerGrey">
                    Jump to your dashboard for active orders.
                  </p>
                </div>
                <div className="flex items-center gap-3 rounded-2xl bg-white border border-greyBorder px-4 py-3">
                  <div className="h-10 w-10 rounded-full bg-orange/20 flex items-center justify-center text-primary font-fraunces-bold">
                    3
                  </div>
                  <p className="text-base font-source text-headerGrey">
                    Reach out for priority support.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default NotFound;
